export const getCurrLeadId = () => {
    const leadId = window.AMOCRM.data.current_card.id;
    return leadId
}